import { Component, HostBinding, Injector, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppComponent } from 'src/app/app.component';
import { IPage } from 'src/app/page.interface';
import { VSidebarComponent } from 'src/app/v-sidebar/v-sidebar.component';
import { APIState, APIStates, InternalAppService } from 'src/services/app.service';
import { SubType } from 'src/util/types/global';
import { VLeftSidebarComponent } from '../v-left-sidebar/v-left-sidebar.component';
import { GCValidators } from 'src/app/validators';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from "src/environments/environment";
import { VComponentsModule } from 'src/app/modules/wrappers';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../components.module';
import { GcLayoutModule } from '../v-layout/layout.module';
import { ToolbarModule } from 'primeng/toolbar';
import { PopoverModule } from 'primeng/popover';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { BadgeModule } from 'primeng/badge';
import { PrimeNG } from 'primeng/config';
import { FeatureFlags } from '@vierkant-software/types__api';
interface City {
  name: string;
  code: string;
}

/**
* @ignore - do not show in documentation
*/
@Component({
  selector:    'v-top-bar',
  templateUrl: './v-top-bar.component.haml',
  styleUrls:   ['./v-top-bar.component.sass'],
  standalone:  true,
  imports:     [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BadgeModule,
    GcLayoutModule,
    ComponentsModule,
    PopoverModule,
    PasswordModule,
    DialogModule,
    ToolbarModule,
    VComponentsModule,
  ]
})
export class VTopBarComponent implements OnInit {
  @HostBinding('attr.role') public readonly role = "banner";
  static instance: VTopBarComponent;
  private leftSidebar?: VLeftSidebarComponent;
  private rightSideBar?: VSidebarComponent;
  private mainComponent?: IPage;
  // tabSelect: string = "/product-management";

  //display: boolean = true;

  get display() {
    return this.appService.pageService.showTopBar;
  }

  value1: string = '';
  cities: City[];
  selectedCity: City;
  items: MenuItem[];
  user: SubType<APIState, APIStates.loggedIn> = null;

  userAvatar: SafeUrl;
  studioName: string;
  public readonly fWorkflow = FeatureFlags.workflow;

  //for change password
  passDialog: boolean = false;
  userPass: FormGroup;
  medium = /\S{6,}/;
  strong = /\S{8,}/;

  public infoVisible = false;

  // menuTabs = [
  //   {label: "Produkte", path: "/product-management"},
  //   {label: "Kunden", path: "/"},
  //   {label: "Warenkörbe", path: "/"},
  // ];

  constructor(
    private primengConfig: PrimeNG,
    public appService: InternalAppService,
    private injector: Injector,
    private router: Router,
    private appComponent: AppComponent,
    private formBuilder: FormBuilder,
  ) {
    this.appService.$APIState.forEach((res: APIState) => {
      switch(res.type) {
        case APIStates.connected:
          this.studioName = res.studioName;
          break;
        case APIStates.loggedIn:
          this.studioName = res.studioName;
          this.user = res;
          this.userAvatar = res.avatar;
          break;
      }
    }).catch(() => null as null);

    VTopBarComponent.instance = this;
    this.cities = [
      {name: 'Application', code: 'app'},
      {name: 'This Site', code: 'site'}
    ];

    this.userPass = this.formBuilder.group({
        oldPassword:        ['', GCValidators.required],
        newPassword:        ['', [GCValidators.required, Validators.minLength(8)]],
        confirmNewPassword: ['', [GCValidators.required, Validators.minLength(8)]]
    }, { validators: (form: FormGroup) => {
            const error = this.isSame(form) ? false : {required: true};
            return error;
        }
    });
  }

  public get isProd() {
    return !!environment.production;
  }

//   async navigateTo(path: string) {
//     await this.router.navigate([this.tabSelect]).catch(e => console.error(e));
//   }

  changeTheme() {
    let themName: 'hmm' | undefined;
    if (this.appService.theme() === 'hmm')
        themName = undefined;
    else
        themName = 'hmm';
    this.appService.theme.set(themName);
  }

  hideMenu() {
    this.appService.hideMenu.set(!this.appService.hideMenu());
  }

  get notification() {
    return this.appService.workflowService.topBarCategory;
  }

  openWorkflow() {
    this.router.navigate(['/workflow']).catch(e => console.error(e));
  }

  ngOnInit() {
    this.leftSidebar = this.injector.get(VLeftSidebarComponent);
    this.rightSideBar = this.injector.get(VSidebarComponent);
    this.primengConfig.ripple.set(true);
    this.items = [
      {
          label: 'File',
          items: [{
                  label: 'New',
                  icon:  'pi pi-fw pi-plus',
                  items: [
                      {label: 'Project'},
                      {label: 'Other'},
                  ]
              },
              {label: 'Open'},
              {label: 'Quit'}
          ]
      },
      {
          label: 'Edit',
          icon:  'pi pi-fw pi-pencil',
          items: [
              {label: 'Delete', icon: 'pi pi-fw pi-trash'},
              {label: 'Refresh', icon: 'pi pi-fw pi-refresh'}
          ]
      }
    ];
  }

  //for changing the [disabled] state of dialog button
  isFormValid(){
    return this.userPass.valid;
  }

  showChangePassword(){
    this.passDialog = !this.passDialog;
  }

  onCancel(){
    this.passDialog = false;
    this.userPass.reset();
  }

  isSame(form: FormGroup = this.userPass){
    const a = form.get('newPassword').value;
    const b = form.get('confirmNewPassword').value;
    if ([null, undefined, ''].includes(a) || [null, undefined, ''].includes(b))
        return true;
    return  a === b;
  }

  async onConfirm(){
    try {
        await this.appService.api.AuthWorker.changePassword(this.userPass.value.oldPassword, this.userPass.value.newPassword);
        this.userPass.reset();
        this.passDialog = false;
    } catch(error) {
        this.appService.messageService.add({
            severity: 'error',
            summary:  'Passwort konnte nicht geaendert werden.',
            detail:   error.msg
        });
        console.error(error);
    }
  }

  async logout() {
    // await this.internalAppService.__logout();
    // await this.router.navigate(['/login']);
    await this.router.navigate(['/logout']);
  }

  // openStudioSwitchSidebar() {
  //   this.appComponent.studioSwitchVisible = StudioSwitchVisible.sidebar;
  // }

}
